import { Controller } from '@stimulus/core';
export default class extends Controller {
    success() {
        alert('字幕の作成をスケジュールしました。');
    }
    error() {
        alert('エラー');
    }
}
